import { Helmet } from "react-helmet-async";
import PageText from "../../components/PageText";

export default function AllGameplayPost() {
  const articleJsonLd = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: "Why CHAOTIK allows all gameplay permitted by CIG/RSI",
    author: { "@type": "Organization", name: "CHAOTIK" },
    publisher: {
      "@type": "Organization",
      name: "CHAOTIK",
      logo: {
        "@type": "ImageObject",
        url: "https://chaotik.org/assets/logo-main.png",
      },
    },
    datePublished: "2026-05-01",
    description:
      "CHAOTIK's stance: if it's allowed in Star Citizen, it's allowed with us. Here's why we picked that policy and how it works in practice.",
    mainEntityOfPage: "https://chaotik.org/blog",
  };

  return (
    <article className="bg-black/40 backdrop-blur-md rounded-lg p-6 sm:p-8 md:p-10 mb-12 text-left border border-red-500/40 shadow-[0_0_20px_rgba(248,113,113,0.35)]">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(articleJsonLd)}</script>
      </Helmet>
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bebas tracking-wide uppercase mb-6 text-white">
        Why CHAOTIK allows all gameplay permitted by CIG/RSI
      </h1>
      <p className="text-white/60 text-sm mb-8">May 2026</p>

      <PageText>
        <p className="mb-4">
          A lot of Star Citizen orgs draw hard moral lines: this org doesn't pirate, that org
          doesn't grief, the next one only flies lawful. Fine. CHAOTIK isn't one of those. Our
          rule is simpler: if it's allowed by the CIG/RSI Terms of Service, it's allowed with
          us.
        </p>
        <p className="mb-4">
          That's not a shrug &mdash; it's a deliberate choice. The verse CIG is building is
          messy on purpose. Bounty hunters and pirates share contract boards. Cargo runs cross
          contested space. Industrial ops happen next door to combat zones. Exploration drags
          you into both. Carving an org's behaviour into &ldquo;always-lawful&rdquo; chunks
          leaves half the game's content untouched, and pretends a moral cleanliness the
          universe itself doesn't enforce.
        </p>
        <p className="mb-4">
          The one rule that does apply is the obvious one: Wheaton's Law. Don't be a dick to
          other CHAOTIK members and don't be a dick in our voice channels. Outside of that, if
          a member wants to take a contract that puts them across the table from another
          member's wing, that's a Tuesday.
        </p>
        <p className="mb-4">
          This is also a recruiting filter. Players who want a strict roleplay-lawful org know
          immediately we're not it. Players who want flexibility &mdash; combat one night,
          mining the next, a cargo run or bounty contract at the weekend &mdash; tend to stick
          around. The result is a roster that actually plays together instead of self-selecting
          around a rule book.
        </p>
        <p className="mb-4">
          If the philosophy clicks, the{" "}
          <a
            href="https://discord.gg/CHAOTIK"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#96000b] underline hover:text-red-400"
          >
            Discord
          </a>{" "}
          is the front door. Hop in, say hi, and fly with us.
        </p>
      </PageText>
    </article>
  );
}
